function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import "./Toggle.css";
export default class Toggle extends Component {
  render() {
    const {
      align,
      children,
      disabled,
      size,
      toggled,
      onToggle,
      ...rest
    } = this.props;
    const classes = classnames("ax-toggle", `ax-toggle--${size}`, `ax-toggle--align-${align}`, {
      "ax-toggle--enabled": !disabled
    });
    return /*#__PURE__*/React.createElement(Base, {
      Component: "label",
      className: classes,
      space: "x2"
    }, children && /*#__PURE__*/React.createElement("span", {
      className: "ax-toggle__label"
    }, children), /*#__PURE__*/React.createElement("span", {
      className: "ax-toggle__switch"
    }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
      checked: toggled,
      className: "ax-toggle__input",
      disabled: disabled,
      onChange: onToggle,
      type: "checkbox"
    })), /*#__PURE__*/React.createElement("span", {
      className: "ax-toggle__appearance"
    })));
  }

}

_defineProperty(Toggle, "defaultProps", {
  align: "left",
  size: "small"
});